/* istanbul ignore file */
const styles = ({
  palette: {
    text: { light }
  },
  spacing: { unit },
  typography: { fontWeightHeavy, fontWeightRegular, headline3, mainTitle, title },
  workflow: {
    extraBox: { amount, subtext },
    footer
  }
}) => ({
  section: {
    '& fieldset': {
      border: 'none'
    },
    '& .create-payment__top-section__row': {
      display: 'inline-block',
      '& label button': {
        fontWeight: fontWeightRegular
      }
    }
  },
  paymentContent: {
    padding: '12px 44px'
  },
  paymentForm: {
    '& fieldset:first-of-type': {
      margin: `0 0 ${unit * 3}px`,
      paddingBottom: unit * 2
    },
    '& .form-group.flex-dropdown-wrapper': {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  workflow: {
    padding: '12px 44px'
  },
  paymentFormView: {
    padding: `${unit * 3.75}px 0`
  },
  amount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  currentAmount: {
    fontFamily: headline3.fontFamily,
    fontSize: headline3.fontSize,
    fontWeight: headline3.fontWeight,
    margin: 'auto',
    '& span.amount': {
      ...amount
    },
    '& span.subtext': {
      ...subtext
    }
  },
  value: {
    fontFamily: mainTitle.fontFamily,
    margin: '0 auto',
    '& > span:first-child': {
      fontSize: mainTitle.fontSize,
      fontWeight: fontWeightHeavy,
      lineHeight: `${mainTitle.fontSize}px`
    }
  },
  currency: {
    fontSize: unit * 2.5,
    fontFamily: title.fontFamily,
    marginLeft: unit / 2,
    color: footer.color || light
  },
  desc: {
    display: 'inline-block',
    fontFamily: title.fontFamily,
    fontSize: unit * 1.75,
    textTransform: 'uppercase',
    fontWeight: fontWeightHeavy
  }
});
export default styles;
